import { delay } from 'redux-saga'
import { call, put, take, race, takeLatest } from 'redux-saga/effects'
import axios from 'axios'

import {
  TRACKER_REQUEST,
  TRACKER_SUCCESS,
  TRACKER_FAILURE,
  START_POLLING,
  STOP_POLLING
} from '../../actions/dashboardActions'
import entorno from '../../config/entorno'

const TRACKER_API = entorno.seguimiento

function* trackerRequest(coordinates) {
  yield put({ type: TRACKER_REQUEST })
  try {
    const { data } = yield call(() =>
      axios.post(`${TRACKER_API}couriers/search`, {
        latitude: coordinates[0],
        longitude: coordinates[1],
        radius: 1500
      })
    )
    yield put({ type: TRACKER_SUCCESS, data })
  } catch (error) {
    yield put({ type: TRACKER_FAILURE, message: error.message })
  }
}

function* pollTracker(coordinates) {
  while (true) {
    yield call(trackerRequest, coordinates)
    yield delay(5000)
  }
}

/**
 * Vigila las peticiones de sondeo.
 *
 * ─── Por qué `takeLatest` y no un `take` dentro de un bucle ─────────────────
 *
 * Antes esto era:
 *
 *     while (true) {
 *       const { coordinates } = yield take(START_POLLING)
 *       yield race([call(pollTracker, coordinates), take(STOP_POLLING)])
 *     }
 *
 * `pollTracker` no termina nunca —es un `while (true)` con su espera—, así que
 * el `race` sólo se resuelve con un `STOP_POLLING`. Mientras tanto el vigilante
 * se quedaba **bloqueado** ahí y no volvía al `take`: cualquier `START_POLLING`
 * posterior se perdía en silencio.
 *
 * El efecto para el operador: pinchaba un mensajero al otro lado de la ciudad
 * —o cambiaba de ciudad— y el rastreador seguía preguntando por mensajeros en
 * un radio de 1500 m alrededor del punto **original**. Ninguna traza, ningún
 * error: simplemente no aparecía nadie.
 *
 * Con `takeLatest`, un aviso nuevo cancela el sondeo en curso y arranca otro
 * con las coordenadas nuevas.
 *
 * ⚠️ Esto **depende** de que el contenedor no despache `START_POLLING` en cada
 * ciclo. `DashboardContainer` lo hacía, porque tenía `isPolling` en las
 * dependencias del efecto y esa bandera se enciende y apaga con cada petición.
 * Con el `take` bloqueado daba igual —se descartaban—, pero con `takeLatest`
 * cada uno cancelaría la espera de 5 s y pediría de nuevo al instante: un bucle
 * a la velocidad de la red. Las dos cosas se corrigieron juntas.
 */
function* watchPollTrackerSaga() {
  yield takeLatest(START_POLLING, function* ({ coordinates }) {
    yield race([call(pollTracker, coordinates), take(STOP_POLLING)])
  })
}

export function* dashboardSaga() {
  yield call(watchPollTrackerSaga)
}
